/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-10-30 20:50:29
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-11 11:29:02
 * @FilePath: \mpc-monorepo\apps\mpc-external\src\containers\SmWorkbench\ProjectDetail\Show\Detail\FirstAskDetail\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import RequirementContent from '@mpc/common/src/features/MPCDemand/KOLInquiryForQuotation/RequirementContent';
import DesignatedExpert from '@mpc/common/src/features/MPCDemand/KOLInquiryForQuotation/DesignatedExpert';
import SFormItem from '@mpc/common/src/components/SForm/SFormItem';
import CustomInspection from '@mpc/common/src/features/CustomInspection';
// import useMPCDemand from '@/model/MPCDemand';
import cx from 'classnames';
import {SupplierKOLTable} from '@mpc/common/src/features/MPCDemand/KOLInquiryForQuotation/SupplierKOLTable';

interface Props {
  detail: any;
  className?: string;
}

const KOLQuote = ({ detail, className }: Props) => {
  // const { setIsQuoteTableFullscreen } = useMPCDemand();
  if (detail?.plan_type !== 2) {
    return null;
  }

  return <div className={cx('flex', className)}>
    <SFormItem
      noStyle
      formItemKey={['demand_source_detail_vo', 'demand_source_supplier_kol_vos']}
      watchChildFormValidate={true}
      validateTrigger={false}
      render={() => (
        <SupplierKOLTable
          view={true}
          detailData={detail}
        />
      )}
    />
  </div>;
};

export default KOLQuote;
